import { Typography } from 'enable-ui';

import type { OnboardingFunctionalTest } from 'modules/learners/core/type';

export const FunctionalTest = ({ item }: { item: OnboardingFunctionalTest }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <img
        src={item.thumbnail}
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
        }}
      />
      <div>
        <Typography
          style={{
            color: '#222',
            fontSize: 18,
            fontWeight: 400,
            lineHeight: '26px',
          }}
        >
          {item.name}
        </Typography>
        <Typography
          style={{
            color: '#808080',
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '22px',
          }}
        >
          {item.method}
        </Typography>
      </div>
    </div>
  );
};
